import {
  getState,
} from './index';


const getErrors = state => getState(state).errors;
export const getDetachGoogleError = state => getErrors(state).detachGoogleError;
export const getDetachTwitterError = state => getErrors(state).detachTwitterError;
export const getLoadSocialError = state => getErrors(state).loadSocialError;
